export const BUSINESS_NAME = "Upper Canada Landscape";
export const PHONE = "519-473-8111";
export const PHONE_HREF = "tel:5194738111";
export const EMAIL = "info@uppercanadalandscape.com";
export const HOURS = "Mon\u2013Fri, 8am \u2013 5pm";
export const YEARS_EXPERIENCE = 30;
export const ADDRESS = "563 Wonderland Rd N, London, ON N6H 3E2";
export const ADDRESS_STREET = "563 Wonderland Rd N";
export const ADDRESS_CITY = "London, ON N6H 3E2";
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=100057832160452";

export const LOGO_URL = "https://uppercanadalandscape.com/wp-content/uploads/2026/03/Upper-Canada-Landscape-Logo-1.webp";
export const BADGE_URL = "https://uppercanadalandscape.com/wp-content/uploads/2026/03/upper-canada-landscape-30-years-serving-london.webp";

export const FORM_ACTION = "https://readdy.ai/api/form/d72mv9kjuufb4jdbl7h0";

export const MAP_EMBED_URL = "https://maps.google.com/maps?q=563+Wonderland+Rd+N,+London,+ON+N6H+3E2&t=&z=16&ie=UTF8&iwloc=&output=embed";

export const SERVICE_AREAS = [
  "London",
  "St. Thomas",
  "Sarnia",
  "Kitchener",
  "Stratford",
  "Grand Bend",
  "Middlesex County",
  "Elgin County",
  "Oxford County",
  "Huron County",
];

export const SERVICES = [
  {
    id: "landscape-design",
    name: "Landscape Design & Construction",
    tagline: "From Concept to Completion",
    description:
      "Complete outdoor landscape planning and construction tailored to your property. From concept drawings through final installation, every detail is handled with artisan care.",
    image:
      "https://uppercanadalandscape.com/wp-content/uploads/2026/03/Large-Stone-Patio-and-Outdoor-Kitchen-with-Lake-View.webp",
    href: "/services",
    features: [
      "Custom design consultation",
      "Full project management",
      "Premium plant selection",
      "Irrigation integration",
      "Post-installation care guide",
    ],
  },
  {
    id: "water-features",
    name: "Water Feature Installation",
    tagline: "Ponds, Waterfalls & Streams",
    description:
      "Ponds, waterfalls, and custom water elements designed to elevate your landscape. Natural-looking, low-maintenance systems built to harmonize with your outdoor environment.",
    image:
      "https://uppercanadalandscape.com/wp-content/uploads/2025/10/upper-canadalands-cape-5.webp",
    href: "/services",
    features: [
      "Custom pond design",
      "Natural stone waterfalls",
      "Aquatic plant integration",
      "Pump & filtration systems",
      "Year-round winterization",
    ],
  },
  {
    id: "synthetic-turf",
    name: "Synthetic Turf Solutions",
    tagline: "Year-Round Beauty, Zero Upkeep",
    description:
      "Low-maintenance turf installations for lawns, pets, and recreational spaces. Premium artificial grass systems that look and feel like the real thing \u2014 12 months a year.",
    image:
      "https://uppercanadalandscape.com/wp-content/uploads/2026/03/Multi-Level-Backyard-Pool-Patio-and-Retaining-Wall-Landscape.webp",
    href: "/services",
    features: [
      "Pet-safe & child-safe materials",
      "Proper drainage systems",
      "Putting greens & sport surfaces",
      "10-year product warranty",
      "No mowing, no watering",
    ],
  },
  {
    id: "stone-hardscape",
    name: "Stone Work & Hardscape",
    tagline: "Patios, Walls & Walkways",
    description:
      "Patios, walkways, retaining walls, and armour stone features built for lasting durability and visual impact. Every slab placed with precision and pride.",
    image:
      "https://uppercanadalandscape.com/wp-content/uploads/2025/10/stone-work-2.webp",
    href: "/services",
    features: [
      "Natural & engineered stone",
      "Armour stone retaining walls",
      "Patterned concrete options",
      "Outdoor kitchen platforms",
      "Structural warranty included",
    ],
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Michael R.",
    location: "London, ON",
    rating: 5,
    text: "Upper Canada Landscape completely transformed our backyard. The stone patio and waterfall feature they built exceeded every expectation. Professional team, flawless execution, and the end result looks like something out of a magazine. Couldn\u2019t be happier.",
  },
  {
    id: 2,
    name: "Sarah T.",
    location: "St. Thomas, ON",
    rating: 5,
    text: "We hired Upper Canada Landscape for a complete backyard redesign \u2014 synthetic turf, armour stone retaining walls, and full garden beds. The craftsmanship is impeccable. They communicated clearly at every stage, finished on time, and cleaned everything up perfectly.",
  },
  {
    id: 3,
    name: "David K.",
    location: "Kitchener, ON",
    rating: 5,
    text: "Three years later and our landscape still looks exactly as beautiful as the day it was installed. The quality of their materials and workmanship is simply unmatched in the area. An investment that paid for itself in curb appeal and enjoyment. Worth every penny.",
  },
];

export const NAV_LINKS = [
  { label: "Services", href: "/services" },
  { label: "About", href: "/about" },
  { label: "Locations", href: "/location" },
];

export const GALLERY_IMAGES = [
  {
    src: "https://uppercanadalandscape.com/wp-content/uploads/2026/03/backyard-putting-green-night-time.webp",
    alt: "Backyard putting green at night",
  },
  {
    src: "https://uppercanadalandscape.com/wp-content/uploads/2025/10/landscaping-design-04.webp",
    alt: "Landscape design",
  },
  {
    src: "https://uppercanadalandscape.com/wp-content/uploads/2026/03/backyard-putting-green.webp",
    alt: "Backyard putting green",
  },
  {
    src: "https://uppercanadalandscape.com/wp-content/uploads/2026/03/Stone-Waterfall-Feature-and-Backyard-Patio-Installation.webp",
    alt: "Stone waterfall feature and patio installation",
  },
  {
    src: "https://uppercanadalandscape.com/wp-content/uploads/2026/03/Modern-Backyard-Pool-House-and-Pool-Landscape-Design.webp",
    alt: "Modern backyard pool and landscape design",
  },
  {
    src: "https://uppercanadalandscape.com/wp-content/uploads/2026/03/artificial-turf-front-yard.webp",
    alt: "Artificial turf front yard",
  },
  {
    src: "https://uppercanadalandscape.com/wp-content/uploads/2026/03/Natural-Stone-Pond-and-Backyard-Waterfall-Feature.webp",
    alt: "Natural stone pond with waterfall",
  },
  {
    src: "https://uppercanadalandscape.com/wp-content/uploads/2025/10/landscaping-design-07.webp",
    alt: "Professional landscape design",
  },
];
